import { useEffect } from "react";
import { PAGES } from "./pageMeta";

const setMeta = (attr, key, value) => {
  const el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.setAttribute("content", value);
};

export function usePageMeta(key, path) {
  useEffect(() => {
    const p = PAGES[key];
    const prev = document.title;
    const origin = window.location.origin;
    document.title = p.title;
    setMeta("name", "description", p.description);
    setMeta("property", "og:title", p.title);
    setMeta("property", "og:description", p.description);
    setMeta("property", "og:image", origin + p.image);
    setMeta("property", "og:url", origin + path);
    setMeta("name", "twitter:title", p.title);
    setMeta("name", "twitter:description", p.description);
    setMeta("name", "twitter:image", origin + p.image);
    return () => {
      document.title = prev;
    };
  }, [key, path]);
}
